export default "/images/team-vous-recrutez.png?5c6e69891ba701b609117974526292eb";